import { render, staticRenderFns } from "./addSchema.vue?vue&type=template&id=79cbce27"
import script from "./addSchema.vue?vue&type=script&lang=js"
export * from "./addSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports